<template>
  <div class="content">
    <div class="container">
      <form method="POST"
            action="#"
            class="form form--restore">
        <header-logo :logo-url="globalLogoUrl" />
        <h1 v-word:layout.passwordRecovery.header></h1>
        <section class="form__section">
          <div class="form__section__links form__section__links--back">
            <p v-word:layout.passwordRecovery.label />
          </div>
        </section>
        <section class="form__section">
          <div class="form__input">
            <input type="text"
                   id="email"
                   v-model.trim="email"
                   v-word="{ word: 'layout.passwordRecovery.email.placeholder', attr: 'placeholder' }">
            <p v-if="usernameError"
               class="form__input__error"
               v-html="usernameError" />
          </div>
        </section>
        <section class="form__section">
          <div class="form__input form__input--submit">
            <button type="submit"
                    @click.prevent="handleSubmit()"
                    v-word:layout.passwordRecovery.button.submit />
          </div>
        </section>
        <section class="form__section">
          <div class="form__section__links form__section__links--back">
            <a class="button"
             :href="!editMode && $router.resolve({ name: 'login' }).href"
             v-word:layout.passwordRecovery.link.backToLogin />
          </div>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';
import wordings from '../utils/wordings';
import config from 'config';
import backendConfig from './../utils/backendConfig';

export default {
  props: ['store'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
  data() {
    return {
      email: '',
      usernameError: '',
    };
  },
  methods: {
    handleSubmit() {
      this.usernameError = '';
      let invalid = false;

      const formData = {
        username: this.email,
      };

      if (!formData.username) {
        wordings().then(
          wordings =>
            (this.usernameError = wordings['validation.errors.required']),
        );
        invalid = true;
      }

      if (invalid) {
        return;
      }

      backendConfig.get().then(({backendUrl}) => {

        const url =
          backendUrl + config.backend.feeds.passwordRecovery + '?sso=' + this.store.brokerData;

        this.$emit('loading');
        this.$http
          .post(url, formData)
          .then(function(resp) {
            this.$emit('loaded');
            this.$router.push({ path: 'restore-password-mail-sent' });
            this.$emit('loaded');
          })
          .catch(function(resp) {
            if (resp.status === 429) {
              this.flash(this.wordings['layout.passwordRecovery.tooManyRequests'], 'warning');
            } else {
              this.flash(this.wordings['flashes.generalError'], 'error');
            }
            this.$emit('loaded');
          });
          // Edge has some problem with finally
          // .finally(() => {
          //   this.$emit('loaded');
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form__input__error {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/RestorePassword.vue